// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabItem-module__font-s-10___lQpea {
  font-size: 10px !important;
}

.TabItem-module__font-s-12___JdFKS {
  font-size: 12px !important;
}

.TabItem-module__font-s-13___kNPxy {
  font-size: 13px !important;
}

.TabItem-module__font-s-14___uocRj {
  font-size: 14px !important;
}

.TabItem-module__font-s-15___jpdnG {
  font-size: 15px !important;
}

.TabItem-module__font-s-16___YLoxI {
  font-size: 16px !important;
}

.TabItem-module__font-s-18___U1LsT {
  font-size: 18px !important;
}

.TabItem-module__font-s-20___LQbjd {
  font-size: 20px !important;
}

.TabItem-module__font-s-22___JdKKY {
  font-size: 22px !important;
}

.TabItem-module__font-s-28___hQUP7 {
  font-size: 28px !important;
}

.TabItem-module__font-w-400___VON_4 {
  font-weight: 400 !important;
}

.TabItem-module__font-w-500___i49XR {
  font-weight: 500 !important;
}

.TabItem-module__font-w-600___tfBfS {
  font-weight: 600 !important;
}

.TabItem-module__font-w-700___S0YkG {
  font-weight: 700 !important;
}

.TabItem-module__p-5___gkYLW {
  padding: 5px !important;
}

.TabItem-module__p-12___RaVwA {
  padding: 12px !important;
}

.TabItem-module__p-16___vJm4l {
  padding: 16px !important;
}

.TabItem-module__p-30___w7mgx {
  padding: 30px !important;
}

.TabItem-module__p-b-0___GAjCv {
  padding-bottom: 0 !important;
}

.TabItem-module__p-b-5___YlXXT {
  padding-bottom: 5px !important;
}

.TabItem-module__p-b-10___OhBaH {
  padding-bottom: 10px !important;
}

.TabItem-module__p-b-12___SnXHl {
  padding-bottom: 12px !important;
}

.TabItem-module__p-b-16___KbIyZ {
  padding-bottom: 16px !important;
}

.TabItem-module__p-b-18___p64qC {
  padding-bottom: 18px !important;
}

.TabItem-module__p-b-20___eAZAP {
  padding-bottom: 20px !important;
}

.TabItem-module__p-b-25___Mt75p {
  padding-bottom: 25px !important;
}

.TabItem-module__p-b-30___fDwyL {
  padding-bottom: 30px !important;
}

.TabItem-module__p-b-50___m_0FR {
  padding-bottom: 50px !important;
}

.TabItem-module__p-t-0___CmFYL {
  padding-top: 0 !important;
}

.TabItem-module__p-t-12___c7zcd {
  padding-top: 12px !important;
}

.TabItem-module__p-t-16___CPJ28 {
  padding-top: 16px !important;
}

.TabItem-module__p-t-18___u0Aa2 {
  padding-top: 18px !important;
}

.TabItem-module__p-t-20___LcN4B {
  padding-top: 20px !important;
}

.TabItem-module__p-t-30___YEzrn {
  padding-top: 30px !important;
}

.TabItem-module__p-t-40___bM_Wq {
  padding-top: 40px !important;
}

.TabItem-module__p-t-50___RqdmC {
  padding-top: 50px !important;
}

.TabItem-module__p-l-20___qtZ6B {
  padding-left: 20px !important;
}

.TabItem-module__p-l-30___pgAK_ {
  padding-left: 30px !important;
}

.TabItem-module__p-l-40___ayqmb {
  padding-left: 40px !important;
}

.TabItem-module__p-r-16___Ubzdq {
  padding-right: 16px !important;
}

.TabItem-module__p-r-20___qm5i7 {
  padding-right: 20px !important;
}

.TabItem-module__p-r-30___oAb03 {
  padding-right: 30px !important;
}

.TabItem-module__p-r-50___P5nsm {
  padding-right: 50px !important;
}

.TabItem-module__p-r-60___alLzj {
  padding-right: 60px !important;
}

.TabItem-module__m-b-1___F7wQj {
  margin-bottom: 1px !important;
}

.TabItem-module__m-b-2____Nymk {
  margin-bottom: 2px !important;
}

.TabItem-module__m-b-6___hjfcw {
  margin-bottom: 6px !important;
}

.TabItem-module__m-b-8___PTety {
  margin-bottom: 8px !important;
}

.TabItem-module__m-b-10___mSOJe {
  margin-bottom: 10px !important;
}

.TabItem-module__m-b-14___RYzU6 {
  margin-bottom: 14px !important;
}

.TabItem-module__m-b-16___oRuOK {
  margin-bottom: 16px !important;
}

.TabItem-module__m-b-20___jxPf_ {
  margin-bottom: 20px !important;
}

.TabItem-module__m-b-22___RgIOd {
  margin-bottom: 22px !important;
}

.TabItem-module__m-b-24___TYtwx {
  margin-bottom: 24px !important;
}

.TabItem-module__m-b-30___xMTxi {
  margin-bottom: 30px !important;
}

.TabItem-module__m-b-32___AWrS7 {
  margin-bottom: 32px !important;
}

.TabItem-module__m-b-40___hm3s_ {
  margin-bottom: 40px !important;
}

.TabItem-module__m-t-2___A1dO_ {
  margin-top: 2px !important;
}

.TabItem-module__m-t-3___ac_39 {
  margin-top: 3px !important;
}

.TabItem-module__m-t-4___K1rjU {
  margin-top: 4px !important;
}

.TabItem-module__m-t-5___sQiHn {
  margin-top: 5px !important;
}

.TabItem-module__m-t-8___YwwVV {
  margin-top: 8px !important;
}

.TabItem-module__m-t-10___FDbZP {
  margin-top: 10px !important;
}

.TabItem-module__m-t-15___qCnm7 {
  margin-top: 15px !important;
}

.TabItem-module__m-t-16___KEHUt {
  margin-top: 16px !important;
}

.TabItem-module__m-t-20___FXVpT {
  margin-top: 20px !important;
}

.TabItem-module__m-t-22___Pz5sn {
  margin-top: 22px !important;
}

.TabItem-module__m-t-30___D8K42 {
  margin-top: 30px !important;
}

.TabItem-module__m-t-32___ZHqyo {
  margin-top: 32px !important;
}

.TabItem-module__m-l-auto____Fo3U {
  margin-left: auto !important;
}

.TabItem-module__m-l-4___Zj5K2 {
  margin-left: 4px !important;
}

.TabItem-module__m-l-5___n8cD2 {
  margin-left: 5px !important;
}

.TabItem-module__m-l-6___icoAE {
  margin-left: 6px !important;
}

.TabItem-module__m-l-8___mlEjO {
  margin-left: 8px !important;
}

.TabItem-module__m-l-10___i1gXY {
  margin-left: 10px !important;
}

.TabItem-module__m-l-16___L8kKF {
  margin-left: 16px !important;
}

.TabItem-module__m-l-20___czban {
  margin-left: 20px !important;
}

.TabItem-module__m-l-24___kE2kJ {
  margin-left: 24px !important;
}

.TabItem-module__m-l-30___PtuJn {
  margin-left: 30px !important;
}

.TabItem-module__m-l-35___UgeNp {
  margin-left: 35px !important;
}

.TabItem-module__m-l-40___txjj4 {
  margin-left: 40px !important;
}

.TabItem-module__m-r-8___AdaG7 {
  margin-right: 8px !important;
}

.TabItem-module__m-r-10___gkxJy {
  margin-right: 10px !important;
}

.TabItem-module__m-r-16___dahE6 {
  margin-right: 16px !important;
}

.TabItem-module__m-r-20___Dow6M {
  margin-right: 20px !important;
}

.TabItem-module__m-r-24___f1sMH {
  margin-right: 24px !important;
}

.TabItem-module__m-r-30___Ngvg_ {
  margin-right: 30px !important;
}

.TabItem-module__m-r-40___CnMVY {
  margin-right: 40px !important;
}

.TabItem-module__border-r-3____ZDu6 {
  border-radius: 3px !important;
}

.TabItem-module__border-r-4___ZpDpC {
  border-radius: 4px !important;
}

.TabItem-module__border-r-6___mqiUe {
  border-radius: 6px !important;
}

.TabItem-module__border-r-10___bNLch {
  border-radius: 10px !important;
}

.TabItem-module__border-r-12___HBzSx {
  border-radius: 12px !important;
}

.TabItem-module__border-r-16___LRo5n {
  border-radius: 16px !important;
}

.TabItem-module__border-r-50___WIPCB {
  border-radius: 50% !important;
}

.TabItem-module__primary-border___bw_h9 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TabItem-module__primary-border-b___Td6DB {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TabItem-module__primary-border-t___de4JJ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TabItem-module__primary-border-l___Ai1dD {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TabItem-module__primary-border-r___F4cIn {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TabItem-module__secondary-border___zc6XC {
  border: 1px solid #637768;
}

.TabItem-module__secondary-border-b___gG0X7 {
  border-bottom: 1px solid #637768;
}

.TabItem-module__secondary-border-t___c2iMX {
  border-top: 1px solid #637768;
}

.TabItem-module__secondary-border-l___N8O9r {
  border-left: 1px solid #637768;
}

.TabItem-module__secondary-border-r___GozF3 {
  border-right: 1px solid #637768;
}

.TabItem-module__gap-0___y11d9 {
  gap: 0 !important;
}

.TabItem-module__gap-2___SPTxC {
  gap: 2px !important;
}

.TabItem-module__gap-4___WaSGd {
  gap: 4px !important;
}

.TabItem-module__gap-5___SVQbu {
  gap: 5px !important;
}

.TabItem-module__gap-6___E1sHG {
  gap: 6px !important;
}

.TabItem-module__gap-8___DcGye {
  gap: 8px !important;
}

.TabItem-module__gap-10___PHBRl {
  gap: 10px !important;
}

.TabItem-module__gap-12___dYrla {
  gap: 12px !important;
}

.TabItem-module__gap-14___lEACL {
  gap: 14px !important;
}

.TabItem-module__gap-16___i0nfc {
  gap: 16px !important;
}

.TabItem-module__gap-18___QMzgr {
  gap: 18px !important;
}

.TabItem-module__gap-20___BQ0t2 {
  gap: 20px !important;
}

.TabItem-module__gap-24___rnNdG {
  gap: 24px !important;
}

.TabItem-module__gap-26___JykDF {
  gap: 26px !important;
}

.TabItem-module__gap-30___I2yy0 {
  gap: 30px !important;
}

.TabItem-module__gap-32___WtMKQ {
  gap: 32px !important;
}

.TabItem-module__gap-40___sbtzF {
  gap: 40px !important;
}

.TabItem-module__gap-50___r_PA_ {
  gap: 50px !important;
}

.TabItem-module__flex-1___B1qvZ {
  flex: 1;
}

.TabItem-module__flex-none___NHmBk {
  flex: none !important;
}

.TabItem-module__flex-column___SM1cE {
  display: flex;
  flex-direction: column !important;
}

.TabItem-module__flex-row___F5tSE {
  display: flex;
  flex-direction: row !important;
}

.TabItem-module__vertically-centered___OPvTs {
  display: flex;
  align-items: center !important;
}

.TabItem-module__horizontally-centered___p6rCO {
  display: flex;
  justify-content: center !important;
}

.TabItem-module__horizontally-end___GjQUT {
  display: flex;
  justify-content: end !important;
}

.TabItem-module__vertically-start___QYYxq {
  display: flex;
  align-items: start !important;
}

.TabItem-module__space-between___lI93Y {
  display: flex;
  justify-content: space-between !important;
}

.TabItem-module__flex-wrap___vjjnI {
  flex-wrap: wrap !important;
}

.TabItem-module__height-100___el4e7 {
  height: 100%;
}

.TabItem-module__width-50___rxAe6 {
  width: 50% !important;
}

.TabItem-module__width-100___Foeg7 {
  width: 100%;
}

.TabItem-module__cursor-pointer___fxcyY {
  cursor: pointer;
}

.TabItem-module__cursor-not-allowed___FzTPM {
  cursor: not-allowed !important;
}

.TabItem-module__absolute-centered___ivyp_ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TabItem-module__absolute___CxgIn {
  position: absolute;
}

.TabItem-module__relative___WZgYh {
  position: relative;
}

.TabItem-module__fixed___ZbY6L {
  position: fixed;
}

.TabItem-module__visible___nqGXe {
  opacity: 1;
}

.TabItem-module__invisible___qNpYN {
  opacity: 0;
}

.TabItem-module__col-90___GycQD {
  width: 90% !important;
}

.TabItem-module__col-auto___nFdBo {
  width: auto !important;
}

.TabItem-module__medical-tabs___Kbo32 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TabItem-module__medical-table-new___Z7Lhr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabItem-module__medical-table-new___Z7Lhr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabItem-module__medical-table-new___Z7Lhr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabItem-module__medical-table-new___Z7Lhr::-webkit-scrollbar-track {
  display: none;
}
.TabItem-module__medical-table-new___Z7Lhr.TabItem-module__no-pagination___E_TVG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabItem-module__medical-table-new___Z7Lhr.TabItem-module__no-pagination___E_TVG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabItem-module__medical-table-new___Z7Lhr.TabItem-module__no-pagination___E_TVG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabItem-module__medical-table-new___Z7Lhr.TabItem-module__no-pagination___E_TVG::-webkit-scrollbar-track {
  display: none;
}

.TabItem-module__medical-table-empty___pqwbB {
  padding: 14px 40px !important;
}

.TabItem-module__icon-btn___BtBAa {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TabItem-module__search-icon___SomYU {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TabItem-module__disable-select___UQtN5 {
  user-select: none;
}

.TabItem-module__break-word___fSCee {
  word-break: break-word;
}

.TabItem-module__popup-clear-btn___TkQ5u {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TabItem-module__scroll-m-b-20___WDKTM {
  scroll-margin-bottom: 20px;
}

.TabItem-module__container___yJ22H {
  color: rgba(55, 88, 68, 0.5019607843);
  cursor: pointer;
  padding: 0 20px;
}
.TabItem-module__container___yJ22H.TabItem-module__selected___BZdF1 {
  color: #375844;
  background-color: #fbf7f2;
}
.TabItem-module__container___yJ22H .TabItem-module__tabIcon___AF0yy {
  width: 12px;
  height: 12px;
  opacity: 0.6;
}
.TabItem-module__container___yJ22H .TabItem-module__tabIcon___AF0yy.TabItem-module__selected___BZdF1 {
  opacity: 1;
}
.TabItem-module__container___yJ22H .TabItem-module__closeIcon___V1Wgg {
  width: 10px;
  height: 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/TabsNavigation/TabItem/TabItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,qCAAA;EACA,eAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,yBAAA;AA8pBJ;AA3pBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;AA6pBJ;AA3pBI;EACE,UAAA;AA6pBN;AAzpBE;EACE,WAAA;EACA,YAAA;AA2pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, lightest);\n  cursor: pointer;\n  padding: 0 20px;\n\n  &.selected {\n    color: get-color(greenNew, dark);\n    background-color: get-color(orangeNew, light);\n  }\n\n  .tabIcon {\n    width: 12px;\n    height: 12px;\n    opacity: 0.6;\n\n    &.selected {\n      opacity: 1;\n    }\n  }\n\n  .closeIcon {\n    width: 10px;\n    height: 10px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TabItem-module__font-s-10___lQpea`,
	"fontS12": `TabItem-module__font-s-12___JdFKS`,
	"fontS13": `TabItem-module__font-s-13___kNPxy`,
	"fontS14": `TabItem-module__font-s-14___uocRj`,
	"fontS15": `TabItem-module__font-s-15___jpdnG`,
	"fontS16": `TabItem-module__font-s-16___YLoxI`,
	"fontS18": `TabItem-module__font-s-18___U1LsT`,
	"fontS20": `TabItem-module__font-s-20___LQbjd`,
	"fontS22": `TabItem-module__font-s-22___JdKKY`,
	"fontS28": `TabItem-module__font-s-28___hQUP7`,
	"fontW400": `TabItem-module__font-w-400___VON_4`,
	"fontW500": `TabItem-module__font-w-500___i49XR`,
	"fontW600": `TabItem-module__font-w-600___tfBfS`,
	"fontW700": `TabItem-module__font-w-700___S0YkG`,
	"p5": `TabItem-module__p-5___gkYLW`,
	"p12": `TabItem-module__p-12___RaVwA`,
	"p16": `TabItem-module__p-16___vJm4l`,
	"p30": `TabItem-module__p-30___w7mgx`,
	"pB0": `TabItem-module__p-b-0___GAjCv`,
	"pB5": `TabItem-module__p-b-5___YlXXT`,
	"pB10": `TabItem-module__p-b-10___OhBaH`,
	"pB12": `TabItem-module__p-b-12___SnXHl`,
	"pB16": `TabItem-module__p-b-16___KbIyZ`,
	"pB18": `TabItem-module__p-b-18___p64qC`,
	"pB20": `TabItem-module__p-b-20___eAZAP`,
	"pB25": `TabItem-module__p-b-25___Mt75p`,
	"pB30": `TabItem-module__p-b-30___fDwyL`,
	"pB50": `TabItem-module__p-b-50___m_0FR`,
	"pT0": `TabItem-module__p-t-0___CmFYL`,
	"pT12": `TabItem-module__p-t-12___c7zcd`,
	"pT16": `TabItem-module__p-t-16___CPJ28`,
	"pT18": `TabItem-module__p-t-18___u0Aa2`,
	"pT20": `TabItem-module__p-t-20___LcN4B`,
	"pT30": `TabItem-module__p-t-30___YEzrn`,
	"pT40": `TabItem-module__p-t-40___bM_Wq`,
	"pT50": `TabItem-module__p-t-50___RqdmC`,
	"pL20": `TabItem-module__p-l-20___qtZ6B`,
	"pL30": `TabItem-module__p-l-30___pgAK_`,
	"pL40": `TabItem-module__p-l-40___ayqmb`,
	"pR16": `TabItem-module__p-r-16___Ubzdq`,
	"pR20": `TabItem-module__p-r-20___qm5i7`,
	"pR30": `TabItem-module__p-r-30___oAb03`,
	"pR50": `TabItem-module__p-r-50___P5nsm`,
	"pR60": `TabItem-module__p-r-60___alLzj`,
	"mB1": `TabItem-module__m-b-1___F7wQj`,
	"mB2": `TabItem-module__m-b-2____Nymk`,
	"mB6": `TabItem-module__m-b-6___hjfcw`,
	"mB8": `TabItem-module__m-b-8___PTety`,
	"mB10": `TabItem-module__m-b-10___mSOJe`,
	"mB14": `TabItem-module__m-b-14___RYzU6`,
	"mB16": `TabItem-module__m-b-16___oRuOK`,
	"mB20": `TabItem-module__m-b-20___jxPf_`,
	"mB22": `TabItem-module__m-b-22___RgIOd`,
	"mB24": `TabItem-module__m-b-24___TYtwx`,
	"mB30": `TabItem-module__m-b-30___xMTxi`,
	"mB32": `TabItem-module__m-b-32___AWrS7`,
	"mB40": `TabItem-module__m-b-40___hm3s_`,
	"mT2": `TabItem-module__m-t-2___A1dO_`,
	"mT3": `TabItem-module__m-t-3___ac_39`,
	"mT4": `TabItem-module__m-t-4___K1rjU`,
	"mT5": `TabItem-module__m-t-5___sQiHn`,
	"mT8": `TabItem-module__m-t-8___YwwVV`,
	"mT10": `TabItem-module__m-t-10___FDbZP`,
	"mT15": `TabItem-module__m-t-15___qCnm7`,
	"mT16": `TabItem-module__m-t-16___KEHUt`,
	"mT20": `TabItem-module__m-t-20___FXVpT`,
	"mT22": `TabItem-module__m-t-22___Pz5sn`,
	"mT30": `TabItem-module__m-t-30___D8K42`,
	"mT32": `TabItem-module__m-t-32___ZHqyo`,
	"mLAuto": `TabItem-module__m-l-auto____Fo3U`,
	"mL4": `TabItem-module__m-l-4___Zj5K2`,
	"mL5": `TabItem-module__m-l-5___n8cD2`,
	"mL6": `TabItem-module__m-l-6___icoAE`,
	"mL8": `TabItem-module__m-l-8___mlEjO`,
	"mL10": `TabItem-module__m-l-10___i1gXY`,
	"mL16": `TabItem-module__m-l-16___L8kKF`,
	"mL20": `TabItem-module__m-l-20___czban`,
	"mL24": `TabItem-module__m-l-24___kE2kJ`,
	"mL30": `TabItem-module__m-l-30___PtuJn`,
	"mL35": `TabItem-module__m-l-35___UgeNp`,
	"mL40": `TabItem-module__m-l-40___txjj4`,
	"mR8": `TabItem-module__m-r-8___AdaG7`,
	"mR10": `TabItem-module__m-r-10___gkxJy`,
	"mR16": `TabItem-module__m-r-16___dahE6`,
	"mR20": `TabItem-module__m-r-20___Dow6M`,
	"mR24": `TabItem-module__m-r-24___f1sMH`,
	"mR30": `TabItem-module__m-r-30___Ngvg_`,
	"mR40": `TabItem-module__m-r-40___CnMVY`,
	"borderR3": `TabItem-module__border-r-3____ZDu6`,
	"borderR4": `TabItem-module__border-r-4___ZpDpC`,
	"borderR6": `TabItem-module__border-r-6___mqiUe`,
	"borderR10": `TabItem-module__border-r-10___bNLch`,
	"borderR12": `TabItem-module__border-r-12___HBzSx`,
	"borderR16": `TabItem-module__border-r-16___LRo5n`,
	"borderR50": `TabItem-module__border-r-50___WIPCB`,
	"primaryBorder": `TabItem-module__primary-border___bw_h9`,
	"primaryBorderB": `TabItem-module__primary-border-b___Td6DB`,
	"primaryBorderT": `TabItem-module__primary-border-t___de4JJ`,
	"primaryBorderL": `TabItem-module__primary-border-l___Ai1dD`,
	"primaryBorderR": `TabItem-module__primary-border-r___F4cIn`,
	"secondaryBorder": `TabItem-module__secondary-border___zc6XC`,
	"secondaryBorderB": `TabItem-module__secondary-border-b___gG0X7`,
	"secondaryBorderT": `TabItem-module__secondary-border-t___c2iMX`,
	"secondaryBorderL": `TabItem-module__secondary-border-l___N8O9r`,
	"secondaryBorderR": `TabItem-module__secondary-border-r___GozF3`,
	"gap0": `TabItem-module__gap-0___y11d9`,
	"gap2": `TabItem-module__gap-2___SPTxC`,
	"gap4": `TabItem-module__gap-4___WaSGd`,
	"gap5": `TabItem-module__gap-5___SVQbu`,
	"gap6": `TabItem-module__gap-6___E1sHG`,
	"gap8": `TabItem-module__gap-8___DcGye`,
	"gap10": `TabItem-module__gap-10___PHBRl`,
	"gap12": `TabItem-module__gap-12___dYrla`,
	"gap14": `TabItem-module__gap-14___lEACL`,
	"gap16": `TabItem-module__gap-16___i0nfc`,
	"gap18": `TabItem-module__gap-18___QMzgr`,
	"gap20": `TabItem-module__gap-20___BQ0t2`,
	"gap24": `TabItem-module__gap-24___rnNdG`,
	"gap26": `TabItem-module__gap-26___JykDF`,
	"gap30": `TabItem-module__gap-30___I2yy0`,
	"gap32": `TabItem-module__gap-32___WtMKQ`,
	"gap40": `TabItem-module__gap-40___sbtzF`,
	"gap50": `TabItem-module__gap-50___r_PA_`,
	"flex1": `TabItem-module__flex-1___B1qvZ`,
	"flexNone": `TabItem-module__flex-none___NHmBk`,
	"flexColumn": `TabItem-module__flex-column___SM1cE`,
	"flexRow": `TabItem-module__flex-row___F5tSE`,
	"verticallyCentered": `TabItem-module__vertically-centered___OPvTs`,
	"horizontallyCentered": `TabItem-module__horizontally-centered___p6rCO`,
	"horizontallyEnd": `TabItem-module__horizontally-end___GjQUT`,
	"verticallyStart": `TabItem-module__vertically-start___QYYxq`,
	"spaceBetween": `TabItem-module__space-between___lI93Y`,
	"flexWrap": `TabItem-module__flex-wrap___vjjnI`,
	"height100": `TabItem-module__height-100___el4e7`,
	"width50": `TabItem-module__width-50___rxAe6`,
	"width100": `TabItem-module__width-100___Foeg7`,
	"cursorPointer": `TabItem-module__cursor-pointer___fxcyY`,
	"cursorNotAllowed": `TabItem-module__cursor-not-allowed___FzTPM`,
	"absoluteCentered": `TabItem-module__absolute-centered___ivyp_`,
	"absolute": `TabItem-module__absolute___CxgIn`,
	"relative": `TabItem-module__relative___WZgYh`,
	"fixed": `TabItem-module__fixed___ZbY6L`,
	"visible": `TabItem-module__visible___nqGXe`,
	"invisible": `TabItem-module__invisible___qNpYN`,
	"col90": `TabItem-module__col-90___GycQD`,
	"colAuto": `TabItem-module__col-auto___nFdBo`,
	"medicalTabs": `TabItem-module__medical-tabs___Kbo32`,
	"medicalTableNew": `TabItem-module__medical-table-new___Z7Lhr`,
	"noPagination": `TabItem-module__no-pagination___E_TVG`,
	"medicalTableEmpty": `TabItem-module__medical-table-empty___pqwbB`,
	"iconBtn": `TabItem-module__icon-btn___BtBAa`,
	"searchIcon": `TabItem-module__search-icon___SomYU`,
	"disableSelect": `TabItem-module__disable-select___UQtN5`,
	"breakWord": `TabItem-module__break-word___fSCee`,
	"popupClearBtn": `TabItem-module__popup-clear-btn___TkQ5u`,
	"scrollMB20": `TabItem-module__scroll-m-b-20___WDKTM`,
	"container": `TabItem-module__container___yJ22H`,
	"selected": `TabItem-module__selected___BZdF1`,
	"tabIcon": `TabItem-module__tabIcon___AF0yy`,
	"closeIcon": `TabItem-module__closeIcon___V1Wgg`
};
module.exports = ___CSS_LOADER_EXPORT___;
